import InputSlider from '@/components/sections/builder/settings/input-slider';
import React from 'react';

export type PaddingStyleType = {
  top: number;
  bottom: number;
  left: number;
  right: number;
};

type PaddingSettingType = {
  value?: PaddingStyleType;
  hideRight?: boolean;
  hideLeft?: boolean;
  onChange?: (padding?: PaddingStyleType) => void;
};

export default function PaddingSetting({
  value,
  onChange,
  hideLeft = false,
  hideRight = false,
}: PaddingSettingType) {
  const padding: PaddingStyleType = value || {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  };

  const onChangePadding = (value: { [key: string]: number }) => {
    onChange?.({
      ...padding,
      ...value,
    });
  };

  return (
    <>
      <div className='mb-2 mt-4 font-bold'>Padding</div>
      <div className='flex items-center'>
        <div className='w-16 text-xs'>Top</div>
        <div className='w-full'>
          <InputSlider
            value={padding.top}
            onChange={(val) =>
              onChangePadding({
                top: val,
              })
            }
            rightContent='px'
          />
        </div>
      </div>
      <div className='flex items-center'>
        <div className='w-16 text-xs'>Bottom</div>
        <div className='w-full'>
          <InputSlider
            value={padding.bottom}
            onChange={(val) =>
              onChangePadding({
                bottom: val,
              })
            }
            rightContent='px'
          />
        </div>
      </div>
      {!hideLeft && (
        <div className='flex items-center'>
          <div className='w-16 text-xs'>Left</div>
          <div className='w-full'>
            <InputSlider
              value={padding.left}
              onChange={(val) =>
                onChangePadding({
                  left: val,
                })
              }
              rightContent='px'
            />
          </div>
        </div>
      )}
      {!hideRight && (
        <div className='flex items-center'>
          <div className='w-16 text-xs'>Right</div>
          <div className='w-full'>
            <InputSlider
              value={padding.right}
              onChange={(val) =>
                onChangePadding({
                  right: val,
                })
              }
              rightContent='px'
            />
          </div>
        </div>
      )}
    </>
  );
}
